import InputText from "./input-text";

export default InputText;